<!--
* @Author: zhangping
* @Date: 2025-09-23 11:08:19
* @Description: 规格弹框
-->

<template>
    <Modal v-model="isShow" title="标题" :mask-closable="false" @on-cancel="onCancel" :width="600">
        <div class="main">
            <div class="mb-10" style="color: #2d8cf0">
                <span>￥</span>
                <span class="fs-36 ml-2">{{ realNumPrice || minimumPrice }}</span>
                <span class="ml-4" v-if="!realNumPrice">起</span>
            </div>
            <div v-for="(bigItem, bigIndex) in specList" :key="bigIndex" class="mb-10">
                <div class="mb-5">{{ bigItem.specName }}</div>
                <div class="mb-10">
                    <div
                        v-for="smallItem in bigItem.specValueInfo"
                        :key="smallItem.id"
                        :class="[
                            'main-option dib',
                            { selectedOption: selectedOptions[bigItem.specName] === smallItem.specValueId },
                            { disabledOption: isOptionDisabled(bigItem.specName, smallItem.specValueId) },
                        ]"
                        @click="
                            isOptionDisabled(bigItem.specName, smallItem.specValueId)
                                ? null
                                : selectOption(bigItem.specName, smallItem.specValueId)
                        "
                        :disabled="isOptionDisabled(bigItem.specName, smallItem.specValueId)"
                        class="mr-10 mb-10"
                    >
                        {{ smallItem.specName }}
                    </div>
                </div>
            </div>
        </div>
        <div slot="footer">
            <Button type="text" @click="onCancel">取消</Button>
            <Button type="primary" :disabled="!realNumPrice" @click="onOk"> 确定 </Button>
        </div>
    </Modal>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash';
export default {
    data() {
        return {
            isShow: false,
            specList: [],
            skuList: [],
            onShelfSkuList: [],
            selectedOptions: {},
            minimumPrice: '',
            realNumPrice: '',
            brandSkuId: '',
        };
    },
    methods: {
        open(row) {
            const _row = cloneDeep(row);
            this.specList = _row.specInfoList;
            this.skuList = _row.onShelfSkuList.map((item) => {
                let specs = {};
                item.specValueIds.split(',').forEach((id, idx) => {
                    const _specName = _row.specInfoList[idx]?.specName;
                    specs[_specName] = Number(id);
                });
                return { specs };
            });
            this.onShelfSkuList = _row.onShelfSkuList;
            this.selectedOptions = _row.selectedOptions || {};
            this.minimumPrice = _row.minimumPrice;
            this.realNumPrice = _row.realNumPrice;
            this.brandSkuId = _row.brandSkuId;
            this.isShow = true;
        },
        onCancel() {
            this.isShow = false;
        },
        onOk() {
            let idList = Object.values(this.selectedOptions);
            let idListToLabel = [];
            this.specList.map((bigItem) => {
                bigItem.specValueInfo.map((smallItem) => {
                    if (idList.includes(smallItem.specValueId)) {
                        smallItem.disabled = true;
                        idListToLabel.push(smallItem.specName);
                    }
                });
            });
            this.$emit('onSuccess', this.selectedOptions, idListToLabel.join('; '), this.realNumPrice, this.brandSkuId);
            this.onCancel();
        },
        isOptionDisabled(groupName, optionId) {
            if (this.selectedOptions[groupName] === optionId) {
                return false;
            }
            const tempSelected = { ...this.selectedOptions, [groupName]: optionId };
            return !this.skuList.some((sku) => {
                return Object.entries(tempSelected).every(([gName, optId]) => {
                    return sku.specs[gName] === optId;
                });
            });
        },
        selectOption(groupName, optionId) {
            if (this.selectedOptions[groupName] === optionId) {
                this.$delete(this.selectedOptions, groupName);
            } else {
                this.$set(this.selectedOptions, groupName, optionId);
            }
            const matchedSku = this.onShelfSkuList.find((item) => {
                return isEqual(
                    Object.values(this.selectedOptions)
                        .sort()
                        .map((el) => String(el)),
                    item.specValueIds.split(',').sort(),
                );
            });
            this.brandSkuId = matchedSku?.brandSkuId;
            this.realNumPrice = matchedSku?.unitPrice;
        },
    },
};
</script>

<style lang="less" scoped>
.main {
    .main-option {
        text-align: center;
        padding: 4px 4px;
        border-radius: 4px;
        min-width: 70px;
        cursor: pointer;
        transition: all 0.2s ease;
        border: 1px solid #c2c0c0;
        &:hover:not(.disabledOption) {
            border-color: #2d8cf0;
            color: #2d8cf0;
        }
        &.selectedOption {
            color: #2d8cf0;
            border-color: #2d8cf0;
            position: relative;
        }
        &.disabledOption {
            color: #ccc;
            cursor: not-allowed;
            border-color: #eee;
        }
        &.disabledOption:hover {
            transform: none;
        }
    }
}
</style>
